'use client';

import { SeoSpecialtyPageQueryQuery } from '@medprev-web-app/api-graphql-client';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { BrandValues } from '@/app/(main)/(pages)/(institucional)/(index)/_components/brand-values.component';
import { CtaIndexCard } from '@/app/(main)/(pages)/(institucional)/(index)/_components/cta-index-card.component';
import CtaSection from '@/app/(main)/(pages)/(institucional)/(index)/_components/cta/cta-section.component';
import { IndexPost } from '@/app/(main)/(pages)/(institucional)/(index)/_components/index-post.component';
import { IndexProceduresInCity } from '@/app/(main)/(pages)/(institucional)/(index)/_components/index-procedures-in-city.component';
import { ContentContainer } from '@/components/ui/content-container.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { SearchType } from '@/types/most-search-type';

export function SpecialtyContent({ citySpecialty }: { citySpecialty: SeoSpecialtyPageQueryQuery }) {
  const place = {
    city: String(citySpecialty?.location?.name),
    state: String(citySpecialty?.location?.state_abbr),
    slug: String(citySpecialty?.location?.slug),
  };

  return (
    <>
      <ContentContainer className="pt-6">
        <Typography
          data-testid={DataTestIdEnum.INDEXING_SPECIALTY_PAGE_TITLE}
          variant={TypographyVariant.TITLE}
          className="px-5 md:px-0 font-bold mb-3 text-center xl:text-left"
        >
          {`${citySpecialty?.seoSpecialtyBySlug?.name} em ${citySpecialty?.location?.city_and_state}`}
        </Typography>

        <Typography variant={TypographyVariant.BODY_TEXT} className="mb-4 text-center xl:text-left">
          Aproveite os valores reduzidos e agende agora a sua consulta.
        </Typography>

        <div className="gap-4 flex flex-col mb-10 xl:flex-row xl:max-w-lg">
          <CtaSection
            searchType={SearchType.PRESENTIAL_CONSULTATION}
            place={place}
            rules={citySpecialty?.location?.businessModelByCity}
            procedure={citySpecialty?.seoSpecialtyBySlug}
            branches={citySpecialty?.location?.branchesByCity?.filter((branch) => branch != null)}
            originCta="principal"
          />
        </div>
      </ContentContainer>

      <BrandValues />
      <hr />

      <ContentContainer className="px-0 sm:px-0">
        <div className="flex flex-col xl:flex-row xl:gap-6">
          <div className="px-6 sm:px-16 md:px-0">
            <IndexPost post={String(citySpecialty?.seoSpecialtyBySlug?.post)} />

            <CtaIndexCard
              title="Agende uma consulta com valores reduzidos"
              searchType={SearchType.PRESENTIAL_CONSULTATION}
              place={place}
              rules={citySpecialty?.location?.businessModelByCity}
              procedure={citySpecialty?.seoSpecialtyBySlug}
              branches={citySpecialty?.location?.branchesByCity?.filter((branch) => branch != null)}
              originCta="rodape"
            />
          </div>

          <IndexProceduresInCity
            type="especialidades"
            city={String(citySpecialty?.location?.city_and_state)}
            citySlug={String(citySpecialty?.location?.slug)}
            procedureSlug={citySpecialty?.seoSpecialtyBySlug?.slug || ''}
          />
        </div>
      </ContentContainer>
    </>
  );
}
